import { Loader } from '@mantine/core';
export function LoadingScreen() {
  return <div className="flex h-screen w-full items-center justify-center gap-24" data-sentry-component="LoadingScreen" data-sentry-source-file="LoadingScreen.tsx">
      <Loader size="xl" variant="dots" data-sentry-element="Loader" data-sentry-source-file="LoadingScreen.tsx" />
      <Loader size="xl" variant="dots" data-sentry-element="Loader" data-sentry-source-file="LoadingScreen.tsx" />
      <Loader size="xl" variant="dots" data-sentry-element="Loader" data-sentry-source-file="LoadingScreen.tsx" />
    </div>;
}